export const get = (obj: any, path: string | string[], defaultValue?: unknown): any => {
  if (!path) return undefined;

  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  const result = pathArray?.reduce((prevObj, key) => prevObj?.[key], obj);
  return result === undefined ? defaultValue : result;
};
